import React, { useContext, useEffect, useRef, useState } from 'react'
import secureLocalStorage from 'react-secure-storage'
import { MyContext } from '../../Context/MyProvider';
import Btn_loader from '../Btn_loader';
import PageLoading from '../PageLoading';
import ImageLoad from '../ImageLoad';
import { useTranslation } from 'react-i18next';

const Profile = () => {

  const { t } = useTranslation();
  const { BaseUrl, HandleCallApi, setIsToast, setToastMsg, setUserLogin, userlogin } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [profilepic, setProfilePic] = useState("");
  const [selectPic, setSelectPic] = useState("");
  const [menData, setMenData] = useState({ name: "", email: "" });
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [cCode, setCCode] = useState("");
  const [password, setPassword] = useState("");
  const [apiloading, setApiloading] = useState(false);

  const ImgRef = useRef();

  useEffect(() => {
    const LoginData = secureLocalStorage.getItem("Logindata");
    if (LoginData && LoginData !== "null" && LoginData !== "undefined") {
      try {
        const parsed = typeof LoginData === 'string' ? JSON.parse(LoginData) : LoginData;
        if (parsed) {
          const { name, email, profile, phone, country_code } = parsed;
          setMenData({ name: name || "", email: email || "" });
          setName(name || "");
          setEmail(email || "");
          setNumber(phone || "");
          setCCode(country_code || "");
          setPassword("");
          setProfilePic(profile ? BaseUrl + profile : "");
        }
      } catch (e) {
        console.error("Error parsing Logindata in Profile:", e);
      }
    }
    setLoading(false);
  }, [userlogin]);

  const handleSave = async () => {
    if (apiloading) return;

    const user_id = secureLocalStorage.getItem("Userid");
    const ApiData = new FormData();
    ApiData.append("name", name);
    ApiData.append("email", email);
    ApiData.append("country_code", cCode);
    ApiData.append("phone", number);
    ApiData.append("password", password);
    ApiData.append("user_id", user_id);
    ApiData.append("profile", selectPic);

    setApiloading(true);
    const Response = await HandleCallApi("Post", "user/edit_userprofile", ApiData);
    setIsToast(true);
    setToastMsg(Response.data.message);
    setUserLogin(prev => prev + 1);
    secureLocalStorage.setItem("Logindata", JSON.stringify(Response.data.customer));
    setApiloading(false);
  }

  return (
    <div className='profile_page'>
      
      <div className="width_container">
        <div className="flex items-center justify-center">
          <div className="profile_box"> 
            <h1 className='font-bold text-[32px] text-gray-900'>{t("My Profile")}</h1>

            <div className="rounded-[15px] px-[32px] py-[25px] mt-[25px] bg-white shadow">
              <div className="flex items-center gap-[15px]">
                <div className="w-[100px] h-[100px] relative">
                  <ImageLoad url={profilepic} CustomeStyle="w-full h-full object-cover rounded-full" alt={`${menData?.name} ProfilePic`} />

                  <input ref={ImgRef} type="file" accept='image/*' onChange={(e) => { setProfilePic(URL.createObjectURL(e.target.files[0])); setSelectPic(e.target.files[0]) }} className='hidden' />

                  <div className="absolute bottom-[2px] right-[2px]">
                    <button onClick={() => ImgRef.current.click()} className='bg-[--bgcolor] rounded-full p-1 border-[2px] border-white'>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1835 3.81626C19.0952 2.72791 17.3306 2.72791 16.2422 3.81627L14.8371 5.22138L18.7784 9.16266L20.1835 7.75754C21.2719 6.66918 21.2719 4.90462 20.1835 3.81626ZM17.7177 10.2233L13.7765 6.28204L4.78675 15.2718C4.22621 15.8323 3.84719 16.5485 3.69895 17.3272L3.27473 19.5557C3.14277 20.2489 3.75091 20.857 4.4441 20.7251L6.67257 20.3008C7.45131 20.1526 8.16748 19.7736 8.72802 19.213L17.7177 10.2233Z" fill="white" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div>
                  <h1 className='font-bold text-[20px]'>{menData?.name}</h1>
                  <p className='text-gray-600 text-[17px]'>{menData?.email}</p>
                </div>
              </div>
              <div className="mt-[25px]">
                <div>
                  <label>{t("Full Name")}</label>
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} className='w-full border border-gray-300 px-[10px] py-[8px] rounded-[10px] mt-1 focus-within:outline-[--bgcolor]' placeholder={t('Enter full name')} />
                </div>
                <div className="mt-[15px]">
                  <label>{t("Email Address")}</label>
                  <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className='w-full border border-gray-300 px-[10px] py-[8px] rounded-[10px] mt-1 focus-within:outline-[--bgcolor]' placeholder={t('Enter email address')} />
                </div>
                <div className="mt-[15px]">
                  <label>{t("Password")}</label>
                  <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} className='w-full border border-gray-300 px-[10px] py-[8px] rounded-[10px] mt-1 focus-within:outline-[--bgcolor]' placeholder={t('Enter password')} />
                </div>
                <div className="mt-[15px]">
                  <label>{t("Phone Number")}</label>
                  <input type="number" value={number} readOnly className='w-full border border-gray-300 px-[10px] py-[8px] rounded-[10px] mt-1 focus-within:outline-[--bgcolor]' placeholder={t('Enter phone number')} />
                </div>
              </div>
              <button onClick={handleSave} className='w-full h-[40px] bg-[--bgcolor] text-white mt-4 rounded-[10px] font-medium hover:shadow-lg duration-[0.3s]'>
                {apiloading
                  ? <Btn_loader CustomeStyle={"bg-white"} />
                  : t("Save Chanage")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <PageLoading loading={loading} />

    </div>
  )
}

export default Profile